import { StoreContext } from '../../../configuration/StoreContext';

export class ModalStore {
	storeContext: StoreContext;
	constructor(storeContext: StoreContext) {
		this.storeContext = storeContext;
	}
}